var _circle, _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRupee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#8F2DF0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.1478,
    y: 21.7667,
    width: 24.7524,
    height: 21.4667,
    rx: 2.3,
    stroke: "white",
    strokeWidth: 1.53333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7667,
    y: 21.7667,
    width: 26.2127,
    height: 21.4667,
    rx: 2.3,
    fill: "#8E2DF0",
    stroke: "white",
    strokeWidth: 1.53333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9841 26.7996V25.5996H27.2222V26.7996H30.2341C30.8385 26.8016 31.4211 27.0473 31.8706 27.49C32.3201 27.9327 32.605 28.5413 32.671 29.1996H27.2222V30.3996H32.671C32.605 31.0579 32.3201 31.6665 31.8706 32.1092C31.4211 32.5519 30.8385 32.7977 30.2341 32.7996H27.2222V34.2066L32.4886 39.3996L33.2213 38.508L28.6493 33.9996H30.2341C31.13 33.9982 31.9926 33.6268 32.6498 32.9596C33.3069 32.2924 33.7105 31.3783 33.7799 30.3996H35.9841V29.1996H33.7799C33.7171 28.2987 33.3695 27.4499 32.7969 26.7996H35.9841Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.3df25075.svg";
export { ForwardRef as ReactComponent };